import instance from "./axios.base";

const getDistricts = async (cityId) => {
  const res = await instance.get(`/districts/${cityId}`);
  return res.data;
};

export { getDistricts };
